package dev.lingvo.ops.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import dev.lingvo.site.ds.Space
import dev.lingvo.site.ds.TypeScale
import dev.lingvo.site.ds.toSitePalette
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Main
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

val OpsAuthRootStyle = CssStyle.base {
    Modifier.backgroundColor(colorMode.toSitePalette().surfaceBase).styleModifier {
        property("min-height", "100svh")
        property("display", "grid")
        property("place-items", "center")
        property("padding", "clamp(20px, 5vw, 64px)")
    }
}

val OpsAuthCardStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().textPrimary).styleModifier {
        property("width", "min(100%, 440px)")
        property("display", "flex")
        property("flex-direction", "column")
        property("gap", "28px")
        property("min-width", "0")
    }
}

val OpsAuthLockupStyle = CssStyle.base {
    Modifier.fontSize(TypeScale.HeadingSmall).fontWeight(750).styleModifier {
        property("display", "flex")
        property("align-items", "baseline")
        property("flex-wrap", "wrap")
        property("gap", "10px")
    }
}

@Composable
internal fun OpsAuthSurface(title: String, description: String, content: @Composable () -> Unit) {
    val palette = ColorMode.current.toSitePalette()
    Main(OpsAuthRootStyle.toModifier().toAttrs()) {
        Div(OpsAuthCardStyle.toModifier().toAttrs()) {
            Div {
                Div(OpsAuthLockupStyle.toModifier().toAttrs()) {
                    Text("Lingvo")
                    Span(Modifier.color(palette.textSecondary).fontSize(TypeScale.BodySmall).fontWeight(500).toAttrs()) {
                        Text("Operator console")
                    }
                }
                P(Modifier.color(palette.textMuted).fontSize(TypeScale.Small).margin(top = Space.XS, bottom = 0.px).toAttrs()) {
                    Text("ops.lingvo.dev")
                }
            }
            Div {
                H1(Modifier.fontSize(TypeScale.Heading).fontWeight(750).margin(0.px).toAttrs()) { Text(title) }
                P(Modifier.color(palette.textSecondary).fontSize(TypeScale.BodySmall)
                    .margin(top = Space.SM, bottom = 0.px).styleModifier { property("line-height", "1.6") }.toAttrs()) {
                    Text(description)
                }
            }
            content()
        }
    }
}
